// Funzione per caricare uno script e attendere che sia pronto
function loadScript(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.onload = () => resolve(script);
        script.onerror = () => reject(new Error(`Errore nel caricamento dello script ${url}`));
        document.head.appendChild(script);
    });
}

// Funzione principale per inizializzare gli swipe
async function initializeCarouselSwipe() {
    // Controlla se esistono carousel nella pagina per evitare di caricare script inutilmente
    if (document.querySelector('.carousel')) {
        console.log("Carousel trovati. Caricamento librerie per lo swipe...");
        
        try {
            // 1. Carica jQuery (se non è già presente)
            if (typeof jQuery == 'undefined') {
                await loadScript('https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js');
            }

            // 2. Carica jQuery TouchSwipe
            await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jquery.touchswipe/1.6.19/jquery.touchSwipe.min.js');
            
            // 3. Una volta che entrambe le librerie sono cariche, applica la funzione
            console.log("Librerie caricate. Inizializzazione swipe...");
            $(".carousel").swipe({
                swipeLeft: function() {
                    $(this).carousel('next');
                },
                swipeRight: function() {
                    $(this).carousel('prev');
                },
                threshold: 75
            });
            console.log("Swipe attivato su tutti i carousel. ✨");

        } catch (error) {
            console.error("Impossibile inizializzare lo swipe:", error);
        }
    }
}

// Avvia la funzione quando il documento è pronto
document.addEventListener('DOMContentLoaded', initializeCarouselSwipe);